import { Center } from '@zorro/web/design-system';
import React from 'react';

import { SVGIconProps } from '../types';

type Props = SVGIconProps & {
  className?: string;
};

export const DiscountIcon = ({ style, className }: Props) => {
  return (
    <Center style={style} className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <g clipPath="url(#clip0_2818_557)">
          <path
            d="M7.5 12.5L12.5 7.5"
            stroke="#1A1721"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8 9C8.55228 9 9 8.55228 9 8C9 7.44772 8.55228 7 8 7C7.44772 7 7 7.44772 7 8C7 8.55228 7.44772 9 8 9Z"
            fill="#1A1721"
          />
          <path
            d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
            fill="#1A1721"
          />
          <path
            d="M4.16665 5.99999C4.16665 5.51376 4.35981 5.04744 4.70363 4.70363C5.04744 4.35981 5.51376 4.16665 5.99999 4.16665H6.83332C7.3174 4.16638 7.78173 3.97466 8.12499 3.63332L8.70832 3.04999C8.87869 2.87865 9.08125 2.74269 9.30436 2.64991C9.52746 2.55713 9.7667 2.50937 10.0083 2.50937C10.2499 2.50937 10.4892 2.55713 10.7123 2.64991C10.9354 2.74269 11.1379 2.87865 11.3083 3.04999L11.8917 3.63332C12.2349 3.97466 12.6992 4.16638 13.1833 4.16665H14.0167C14.5029 4.16665 14.9692 4.35981 15.313 4.70363C15.6568 5.04744 15.85 5.51376 15.85 5.99999V6.83332C15.8503 7.3174 16.042 7.78173 16.3833 8.12499L16.9667 8.70832C17.138 8.87869 17.274 9.08125 17.3667 9.30436C17.4595 9.52746 17.5073 9.7667 17.5073 10.0083C17.5073 10.2499 17.4595 10.4892 17.3667 10.7123C17.274 10.9354 17.138 11.1379 16.9667 11.3083L16.3833 11.8917C16.042 12.2349 15.8503 12.6992 15.85 13.1833V14.0167C15.85 14.5029 15.6568 14.9692 15.313 15.313C14.9692 15.6568 14.5029 15.85 14.0167 15.85H13.1833C12.6992 15.8503 12.2349 16.042 11.8917 16.3833L11.3083 16.9667C11.1379 17.138 10.9354 17.274 10.7123 17.3667C10.4892 17.4595 10.2499 17.5073 10.0083 17.5073C9.7667 17.5073 9.52746 17.4595 9.30436 17.3667C9.08125 17.274 8.87869 17.138 8.70832 16.9667L8.12499 16.3833C7.78173 16.042 7.3174 15.8503 6.83332 15.85H5.99999C5.51376 15.85 5.04744 15.6568 4.70363 15.313C4.35981 14.9692 4.16665 14.5029 4.16665 14.0167V13.1833C4.16638 12.6992 3.97466 12.2349 3.63332 11.8917L3.04999 11.3083C2.87865 11.1379 2.74269 10.9354 2.64991 10.7123C2.55713 10.4892 2.50937 10.2499 2.50937 10.0083C2.50937 9.7667 2.55713 9.52746 2.64991 9.30436C2.74269 9.08125 2.87865 8.87869 3.04999 8.70832L3.63332 8.12499C3.97466 7.78173 4.16638 7.3174 4.16665 6.83332V5.99999"
            stroke="#1A1721"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_2818_557">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </Center>
  );
};
